/**
 * Elegant line-art "guests" icon — sostituisce l'icona Users di Lucide
 * (che ha un look "cartoon-flat") con un tratto sottile più boutique.
 * Due figure leggere, line-only, stroke 1.5.
 */
export default function GuestsIcon({ className = "w-4 h-4", strokeWidth = 1.5 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Adult — front, slightly larger */}
      <circle cx="9" cy="7.5" r="2.6" />
      <path d="M3.5 19.5c0-3.2 2.4-5.2 5.5-5.2s5.5 2 5.5 5.2" />
      {/* Adult — back, slightly behind, hinted only */}
      <circle cx="16.5" cy="8.5" r="2.1" opacity="0.55" />
      <path d="M14.6 14.7c.6-.3 1.3-.4 1.9-.4 2.4 0 4 1.6 4 4" opacity="0.55" />
    </svg>
  );
}
